import { useTranslation } from 'react-i18next'

export function PrivacyPage() {
  const { t } = useTranslation('common')

  return (
    <section className="section-padding bg-white">
      <div className="container-narrow">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-neutral-900 mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-neutral max-w-none">
          <p className="text-neutral-600">
            Bonifanti S.r.l. con sede legale in Via Vigone, 51 - 10068 Villafranca Piemonte (TO),
            in qualità di Titolare del trattamento dei dati personali, ti informa ai sensi
            dell'art. 13 del Regolamento UE 2016/679 (GDPR) che i tuoi dati saranno trattati
            nel rispetto della normativa vigente.
          </p>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Finalità del trattamento
          </h2>
          <p className="text-neutral-600">
            I dati personali raccolti attraverso questo sito vengono trattati per le seguenti finalità:
          </p>
          <ul className="list-disc pl-6 text-neutral-600 space-y-2">
            <li>Rispondere alle richieste inviate tramite il form di contatto</li>
            <li>Inviare newsletter e comunicazioni commerciali (con tuo consenso)</li>
            <li>Gestire la navigazione sul sito e migliorare l'esperienza utente</li>
          </ul>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Base giuridica
          </h2>
          <p className="text-neutral-600">
            Il trattamento dei dati si basa sul consenso dell'interessato, sull'esecuzione
            di misure precontrattuali su richiesta dell'interessato e sul legittimo interesse
            del titolare.
          </p>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Diritti dell'interessato
          </h2>
          <p className="text-neutral-600">
            Hai diritto di accedere ai tuoi dati personali, chiederne la rettifica, la cancellazione,
            la limitazione del trattamento, opporirti al trattamento e richiedere la portabilità dei dati.
          </p>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Contatti
          </h2>
          <p className="text-neutral-600">
            Per esercitare i tuoi diritti o per qualsiasi informazione relativa al trattamento
            dei tuoi dati personali, puoi contattarci all'indirizzo email: {t('contact.email')}
          </p>
        </div>
      </div>
    </section>
  )
}
